import { ReactElement } from 'react'
import { House } from '@mui/icons-material'
import { ToggleButton } from '@ui/actions'

interface Props {
  isBuildingActive: boolean
  onToggleBuilding: () => void
}

/**
 * Toolbar button for the "Gebäude" tool: toggles building mode, which surfaces the BuildingForm in
 * the page drawer. Shared between Structural Planning and IFC Import.
 */
const BuildingToolSelect = ({ isBuildingActive, onToggleBuilding }: Props): ReactElement => (
  <ToggleButton
    hint="Gebäude"
    tooltipPlacement="top"
    size="small"
    onClick={onToggleBuilding}
    selected={isBuildingActive}
    Icon={House}
    data-cy="btn-toggle-building"
  />
)

export default BuildingToolSelect
